"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributedRewardSubjectToJSON = exports.DistributedRewardSubjectFromJSONTyped = exports.DistributedRewardSubjectFromJSON = exports.DistributedRewardSubject = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var DistributedRewardSubject;
(function (DistributedRewardSubject) {
    DistributedRewardSubject["OVERWOLFREWARD"] = "OVERWOLF_REWARD";
    DistributedRewardSubject["QUESTPROGRESSAUTOREWARD"] = "QUEST_PROGRESS_AUTO_REWARD";
    DistributedRewardSubject["MANUALDISTRIBUTION"] = "MANUAL_DISTRIBUTION";
    DistributedRewardSubject["SPONSOREDCOMPETITIONREWARD"] = "SPONSORED_COMPETITION_REWARD";
    DistributedRewardSubject["LOOTBOXREWARD"] = "LOOTBOX_REWARD";
    DistributedRewardSubject["OVERWOLFTIMEREWARD"] = "OVERWOLF_TIME_REWARD";
    DistributedRewardSubject["CHALLENGEREWARD"] = "CHALLENGE_REWARD";
    DistributedRewardSubject["PRIZEPOOL"] = "PRIZE_POOL";
})(DistributedRewardSubject = exports.DistributedRewardSubject || (exports.DistributedRewardSubject = {}));
function DistributedRewardSubjectFromJSON(json) {
    return DistributedRewardSubjectFromJSONTyped(json, false);
}
exports.DistributedRewardSubjectFromJSON = DistributedRewardSubjectFromJSON;
function DistributedRewardSubjectFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.DistributedRewardSubjectFromJSONTyped = DistributedRewardSubjectFromJSONTyped;
function DistributedRewardSubjectToJSON(value) {
    return value;
}
exports.DistributedRewardSubjectToJSON = DistributedRewardSubjectToJSON;
